import script from "./JournalRedirect.vue?vue&type=script&lang=js"
export * from "./JournalRedirect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__